import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  FaPhone,
  FaSignOutAlt,
  FaFilter,
  FaCommentDots,
  FaUserEdit
} from "react-icons/fa";

import api from '../utils/api';
import { useAuth } from '../context/AuthContext';
import './Dashboard.css';

const Dashboard = () => {

  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const [complaints, setComplaints] = useState([]);
  const [statusFilter, setStatusFilter] = useState('all');
  const [loading, setLoading] = useState(true);
  const [corporator, setCorporator] = useState(null);
const [showCorporatorModal, setShowCorporatorModal] = useState(false);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {

    try {

      setLoading(true);

      const complaintsRes = await api.get('/complaints');
      setComplaints(complaintsRes.data.data || []);

    } catch (error) {

      console.error('Dashboard error:', error);
      toast.error('Failed to load dashboard data');

    } finally {

      setLoading(false);

    }

  };

 const handleCallCorporator = async () => {

  try {

    const res = await api.get("/corporator/contact");

    const data = res.data.data || res.data;

    setCorporator(data);
    setShowCorporatorModal(true);

  } catch (err) {

    console.error(err);

    toast.error("Unable to load corporator details");

  }

};

 const handleContact = async (e) => {

  e.stopPropagation();

  try {

    const res = await api.get("/corporator/contact");

    const data = res.data.data || res.data;

    setCorporator(data);
    setShowCorporatorModal(true);

  } catch (err) {

    toast.error("Corporator contact not available");

  }

};

 const handleMessage = (e, itemId) => {

  e.stopPropagation();

  console.log("Clicked complaint:", itemId);

  // alert(`/complaint/${itemId}/chat`);

  navigate(`/complaint/${itemId}/chat`);

};

  const statusMap = {
    open: 'OPEN',
    active: 'IN_PROGRESS',
    closed: 'RESOLVED'
  };

  const filterByStatus = (items) => {

    if (statusFilter === 'all') return items;

    return items.filter(
      item => item.status === statusMap[statusFilter]
    );

  };

  const getStatusBadge = (status) => {

    return (
      <span className={`badge badge-${status?.toLowerCase()}`}>
        {status}
      </span>
    );

  };

  const formatDate = (date) => {

    return new Date(date).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });

  };

  if (loading) {
    return <div className="loading">Loading dashboard...</div>;
  }

  return (

    <div className="dashboard">

      {/* HEADER */}

      <header className="dashboard-header">

        <div className="container">

          <div className="header-content">

            <div>
              <h1>Welcome, {user?.name}!</h1>
              <p>Ward: {user?.ward}</p>
            </div>

            <div className="header-actions">

  <button
    className="btn btn-primary"
    onClick={() => navigate("/edit-profile")}
  >
    <FaUserEdit /> Edit Profile
  </button>

  <button
    className="btn btn-success"
    onClick={handleCallCorporator}
  >
    <FaPhone /> Call Corporator
  </button>

  <button
    className="btn btn-secondary"
    onClick={logout}
  >
    <FaSignOutAlt /> Logout
  </button>

</div>

          </div>

        </div>

      </header>


      <div className="container">

        <div className="dashboard-content">


          {/* QUICK ACTION BUTTONS */}

      <div className="quick-actions">

  <div
    className="action-card"
    onClick={() => navigate("/complaint/new")}
  >
    <div className="action-icon">📝</div>
    <h4>Book Complaint</h4>
    <p>Report civic issues in your ward.</p>
  </div>

  <div
    className="action-card"
    onClick={() => navigate("/request/new")}
  >
    <div className="action-icon">🛠️</div>
    <h4>Service Request</h4>
    <p>Request municipal services.</p>
  </div>

  <div
    className="action-card"
    onClick={() => navigate("/my-service-requests")}
  >
    <div className="action-icon">📋</div>
    <h4>My Requests</h4>
    <p>Track your service requests.</p>
  </div>

  <div
    className="action-card"
    onClick={() => navigate("/suggestion/new")}
  >
    <div className="action-icon">💡</div>
    <h4>Share Suggestion</h4>
    <p>Help improve your city.</p>
  </div>

  <div
    className="action-card"
    onClick={() => navigate("/my-suggestions")}
  >
    <div className="action-icon">📂</div>
    <h4>My Suggestions</h4>
    <p>Track your submitted suggestions.</p>
  </div>

</div>

          {/* FILTER BAR */}

          <div className="filter-bar">

            <FaFilter />

            {['all', 'open', 'active', 'closed'].map(status => (

              <button
                key={status}
                className={`filter-btn ${statusFilter === status ? 'active' : ''}`}
                onClick={() => setStatusFilter(status)}
              >
                {status.toUpperCase()}
              </button>

            ))}

          </div>


          {/* COMPLAINT LIST */}

          <div className="items-list">

            {filterByStatus(complaints).map(complaint => (

              <div
                key={complaint.id}
                className="item-card"
                onClick={() => navigate(`/complaint/${complaint.id}`)}
              >

                <div className="item-header">

                  <h4>{complaint.title}</h4>

                  {getStatusBadge(complaint.status)}

                </div>

                <p className="item-category">
                  {complaint.category?.replace('_', ' ')}
                </p>

                <p className="item-description">
                  {complaint.description}
                </p>

                <div className="item-footer">

                  <span className="item-date">
                    {formatDate(complaint.createdAt)}
                  </span>

                  <div className="item-actions">

                    <button
                      className="btn-icon"
                      onClick={(e) => handleContact(e, complaint.id)}
                    >
                      <FaPhone />
                    </button>

                    <button
                      className="btn-icon"
                      onClick={(e) => handleMessage(e, complaint.id)}
                    >
                      <FaCommentDots />
                    </button>

                  </div>

                </div>

              </div>

            ))}

            {filterByStatus(complaints).length === 0 && (

              <div className="empty-state">
                No complaints found
              </div>

            )}

          </div>

        </div>

      </div>

      {showCorporatorModal && corporator && (

  <div className="modal-overlay">

    <div className="corporator-modal">

      <h2>Corporator Details</h2>

      <div className="detail-row">
        <strong>Name :</strong> {corporator.name}
      </div>

      <div className="detail-row">
        <strong>Ward :</strong> {corporator.ward}
      </div>

      <div className="detail-row">
        <strong>Mobile :</strong> {corporator.mobile}
      </div>

      {corporator.email && (
        <div className="detail-row">
          <strong>Email :</strong> {corporator.email}
        </div>
      )}

      {corporator.address && (
        <div className="detail-row">
          <strong>Address :</strong> {corporator.address}
        </div>
      )}

      <div className="modal-buttons">

        <button
          className="btn btn-success"
          onClick={() =>
            window.location.href = `tel:${corporator.mobile}`
          }
        >
          <FaPhone /> Call Now
        </button>

        <button
          className="btn btn-secondary"
          onClick={() =>
            setShowCorporatorModal(false)
          }
        >
          Close
        </button>

      </div>

    </div>

  </div>

)}

    </div>

  );

};

export default Dashboard;